module.exports = __webpack_public_path__ + "img/vertical_7_1_9005.7fa9761b.png";